<template>
  <b-form-group
    :label="label"
    :label-size="size"
    :label-class="`font-weight-bold ${(validate.required === true || (typeof validate === 'string' && validate.search('required') !== -1) ? 'is-required' : '')}`"
  >
    <ValidationProvider
      v-slot="validationContext"
      ref="inputValidation"
      :name="name"
      :rules="validate"
      :mode="validationMode"
    >
      <b-form-textarea
        v-model="_value"
        :name="name"
        :placeholder="placeholder"
        :rows="rows"
        :state="getValidationState(validationContext)"
        @change="onchange"
        type="text"
      >
      </b-form-textarea>
      <b-form-invalid-feedback
        :state="validationContext.errors.length === 0"
      >
        {{ validationContext.errors.join('. ') }}
      </b-form-invalid-feedback>
    </ValidationProvider>
  </b-form-group>
</template>

<script>
  export default {
    name: 'InputTextareaComponent',
    props: {
      name: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: false,
        default: ''
      },
      placeholder: {
        type: String,
        required: false,
        default: ''
      },
      validate: {
        type: [String, Object],
        required: false,
        default: ''
      },
      size: {
        type: String,
        required: false,
        default: ''
      },
      rows: {
        type: Number,
        default: 3
      },
      onchange: {
        type: Function,
        required: false,
        default: () => {}
      },
      value: {
        type: String,
        required: false,
      },
      validationMode: {
        type: String,
        required: false,
        default: 'passive'
      }
    },
    computed: {
      _value: {
        get () {
          // setTimeout(() => {
          //   this.$refs['inputValidation'].validate()
          // }, 300)
          return this.value
        },
        set (value) {
          this.$emit('update:value', value.trim())
          this.$emit('input', value.trim())
        }
      }
    },
    methods: {
      getValidationState({ validated, valid = null}) {
        return validated ? valid : null
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>